import React from 'react'
import PropTypes from 'prop-types'
import TaskPrompt from 'components/TaskPrompt'
import TaskTimer from 'components/TaskTimer'
import BreakTimer from 'components/BreakTimer'
import BreakPrompt from 'components/BreakPrompt'
import {
  STAGE_TASK_COUNTER,
  STAGE_BREAK_COUNTER,
  STAGE_BREAK_CHOICE,
} from 'constants'

const Home = ({ stage, modalMode }) =>
  modalMode ? (
    <p style={{ textAlign: 'center' }}>You may close this window now</p>
  ) : stage === STAGE_BREAK_CHOICE ? (
    <BreakPrompt />
  ) : stage === STAGE_TASK_COUNTER ? (
    <TaskTimer />
  ) : stage === STAGE_BREAK_COUNTER ? (
    <BreakTimer />
  ) : (
    <TaskPrompt />
  )

Home.propTypes = {
  stage: PropTypes.string.isRequired,
  modalMode: PropTypes.bool.isRequired,
}

export default Home



// WEBPACK FOOTER //
// ./src/routes/Home/components/HomePage/HomePage.js